/**
 * Environment utilities to help differentiate between production and development/test environments
 */

// Using hostname to determine environment
export const isProduction = (): boolean => {
	// return true;
	if (typeof window === "undefined") return false;

	const hostname = window.location.hostname;

	// Production domains
	const productionDomains = ["starch.site", "emporium-drab.vercel.app"];

	return productionDomains.some((domain) => hostname.includes(domain));
};
